module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/passthrough.js
// module id = 1455
// module chunks = 1